import { api } from '../plugins/axios';
import { Paged } from '../types/common';
import { PopUpForm, UpdatePopUpFormDto } from '../types/popupForm';

export const getPopUpForms = (
  query?: string,
  page?: number,
  itemsPerPage?: number
) => {
  const params = {
    page: page || 1,
    itemsPerPage: itemsPerPage || 30,
  };
  return api.get<Paged<PopUpForm>>(`/admin/pop-up-forms?${query}`, {
    params,
  });
};

export const getPopUpForm = (id: number) => {
  return api.get<PopUpForm>(`/admin/pop-up-forms/${id}`);
};

export const patchPopUpForm = (
  id: number,
  data: Partial<UpdatePopUpFormDto>
) => {
  return api.patch<PopUpForm>(`/admin/pop-up-forms/${id}`, data);
};
